import React, { useRef, useState } from 'react';
import BreadcrumbList from '@modules/Sellers/Stock/components/Breadcrumb';
import { Button, Card, message, Spin } from 'antd';
import Popup from '@core/components/Popup';
import { useHistory } from 'react-router';
import deliveryServices from '@modules/Warehouse/Delivery/services/delivery';
import Excel from '@utils/helpers/excel';
import Validate from '@core/validate';

const breadcrumbList = [
  {
    tittle: 'Delivery',
    url: '/admin/delivery'
  },
  {
    tittle: 'CSV file upload',
    url: ''
  }
];

const DeliveryCsv = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form, setForm] = useState<FormData>();
  const inputFileName = useRef<HTMLInputElement | null>(null);
  const [fileName, setFileName] = useState('');

  const handleDownload = async () => {
    const excelOption = {
      blod: await deliveryServices.getTemplateCSV(),
      originalName: 'Delivery_CSV_sheet'
    };
    Excel.download(excelOption);
  }

  const onFileChange = (files: FileList | null) => {
    if (files && files.length) {
      const file = files[0];
      setFileName(file.name);

      const fm = new FormData();
      fm.append('file', file);
      setForm(fm);
    }
  }

  const handleConfirm = () => {
    if (form) {
      setIsModalOpen(true)
    } else {
      Validate.warningEmpty(inputFileName);
    }
  }

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const res = await deliveryServices.createShippingCSV(form!);
      message.success(res.massage);

      history.push('/admin/delivery');
    } catch (error: any) {
      const { response } = error;
      if (response?.data?.message) {
        message.error(response.data.message);
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <BreadcrumbList listBreadcrumb={breadcrumbList} />
      <div className="admin-container ">
        <Spin spinning={loading}>
          <Card
            bordered={false}
            className="admin-card"
            style={{
              minHeight: '80vh',
              background: 'none'
            }}
          >
            <div
              style={{
                padding: '0.5rem 1.5rem',
                marginTop: '1.5rem',
                backgroundColor: '#F9F9F9',
                borderRadius: '0.5rem',
                display: 'flex'
              }}
            >
              <div>
                <strong>💡 Notice</strong>
                <ol style={{marginTop: '20px', fontWeight: '300'}}>
                  <li>
                    When registering for delivery as a CSV file, you need a CSV file that matches the BuskFulfillment form.
                    <br/>
                    Please  button in the upper right corner!
                  </li>
                  <li>Please fill out the form and register the file in the attached file registration section below.</li>
                  <li>If you press the <b style={{fontWeight: 'bold'}}>Save</b> button, the delivery registration is complete! Registered items can be check in the <b style={{fontWeight: 'bold'}}>delivery list.</b></li>
                </ol>
              </div>
              <div className='right'>
                <Button onClick={handleDownload}>Template Download</Button>
              </div>
            </div>
            <div style={{marginTop: '40px'}}>
              <p>Attach CSV File</p>
              <div style={{display: 'flex'}}>
                <input ref={inputFileName} readOnly={true} style={{flex: 1}} value={fileName} />
                <div style={{flex: 2, paddingLeft: '10px'}}>
                  <label className='ant-btn ant-btn-primary' style={{cursor: 'pointer', background: '#3c3d5f', border: 'none', paddingLeft: '30px', paddingRight: '30px'}}>
                    Upload
                    <input className="d-none" type="file"
                           accept=".xlsx, .xls"
                           onChange={(e) => {
                             onFileChange(e.target.files);
                             e.target.value = '';
                           }}
                    />
                  </label>
                </div>
              </div>
            </div>
            <div style={{position: 'absolute', bottom: 0, right: 0, padding: '0 24px 24px 0'}}>
              <Button
                type="primary"
                onClick={handleConfirm}
                style={{cursor: 'pointer', background: '#3c3d5f', border: 'none', padding: '0 30px'}}
              >
                Save
              </Button>
            </div>
          </Card>
        </Spin>
      </div>
      <Popup
        styleBackground="white"
        styleColor="#2A2D51"
        textCancel="Cancel"
        textOk="Save"
        visible={isModalOpen}
        title="Save the delivery information?"
        action_oke={() => {
          handleSubmit();
          setIsModalOpen(false);
        }}
        action_cancel={() => {
          setIsModalOpen(false);
        }}
      />
    </>
  );
}

export default DeliveryCsv;